<template>
    <div class="animated fadeIn">
        <b-card>
            <b-card-body>
                <b-form>
                    <b-form-group label="Показывать технические записи" label-for="basicSelect" :label-cols="3" :horizontal="false   ">
                        <c-switch class="mx-1" color="primary" label variant="pill" v-model="showtech" v-bind="labelIcon"  @change="onChangeShowTech"/>
                    </b-form-group>
                </b-form>
                <v-server-table :url="apiurl('telecall/table')"  :columns="columns" :options="options" :theme="theme" id="telecallsTable" ref="telecallsTable">

                    <a slot="uri" slot-scope="props" :data="data" target="_blank" :href="props.row.uri" class="icon-eye"></a>
                    <div slot="child_row" slot-scope="props">
                        Дата звонка: {{props.row.created_at}}<br>
                        <template v-if="props.row.ring_duration">Длительность дозвона: {{props.row.ring_duration}} с<br></template>
                        <template v-if="props.row.call_duration">Длительность беседы: {{props.row.call_duration}} с<br></template>
                        <template v-if="props.row.record">Запись: <a :href="props.row.record">{{props.row.record}}</a><br></template>

                    </div>
                </v-server-table>

                <p>
                    <small>
                        Поиск по телефонному номеру - 10 правых цифр, все что левее игнорируется
                    </small>
                </p>

            </b-card-body>
        </b-card>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {ServerTable, Event} from 'vue-tables-2'

    import { functions } from '@/functions.js';
    import type from '../jsx/telecalls/type.jsx'
    import event_type from '../jsx/telecalls/event_type.jsx'
    import record from '../jsx/telecalls/record.jsx'
    import {CONSTANTS} from '@/constants';
    import { Switch as cSwitch } from '@coreui/vue'

    Vue.use(ServerTable)

    export default {
        name: 'NsbAdminCalls',
        components: { ServerTable, Event, cSwitch, },
        mixins: [functions],
        data: function () {
            return {
                loading: false,
                showtech: false,
                columns: ['id', 'created_at', 'phone_number', 'telephony_number', 'user_id', 'type', 'event_type', 'record' ],
                labelIcon: {
                    dataOn: '\u2713',
                    dataOff: '\u2715'
                },
                options: {
                    headings: {
                        id: '#',
                        created_at: 'дата/время',
                        phone_number: 'внешний',
                        telephony_number: 'внутренний',
                        user_id: 'user_id',
                        type: 'тип звонка',
                        event_type: 'событие',
                        record: 'запись беседы',
                    },
                    sortable: ['id', 'created_at'],
                    filterable: ['phone_number', 'telephony_number', 'user_id', 'type', 'event_type'],
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    pagination: {
                        chunk: 10,
                        edge: false,
                        nav: 'scroll',
                        dropdown:false
                    },
                    templates: {
                        event_type,
                        type,
                        record
                    },
                    customFilters: [
                        'showtech',
                    ],
                    filterByColumn: true,
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                    saveState: true,
                },
                theme: 'bootstrap4',
                template: 'default'
            }
        },
        methods: {
            onChangeShowTech: function() {
                Event.$emit('vue-tables.filter::showtech', this.showtech?1:0);
            }
        },
        mounted: function () {
            Event.$on('vue-tables.loading', ()=>{ /* this.$eventHub.$emit('loading_start'); */ });
            Event.$on('vue-tables.loaded',()=>{ /*this.$eventHub.$emit('loading_end'); */ });
        },
    };
</script>

<style lang="scss"></style>
